import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import DateField from '../../../FormLegacy/FormFieldsV2/DateField'

import Note from './Note'

const handleDayToggle = (day, setFieldValue, values) => {
  const newSelectedDays = values.selectedDays.includes(day)
    ? values.selectedDays.filter((item) => item !== day)
    : [...values.selectedDays, day]
  setFieldValue('selectedDays', newSelectedDays)
}

export const WeeklyForm = ({ values, setFieldValue, selectedDays }) => {
  const { t } = useTranslation(['visitors'])
  const dayAbbreviations = [
    t('visitors:dayAbbreviations.su'),
    t('visitors:dayAbbreviations.mo'),
    t('visitors:dayAbbreviations.tu'),
    t('visitors:dayAbbreviations.we'),
    t('visitors:dayAbbreviations.th'),
    t('visitors:dayAbbreviations.fr'),
    t('visitors:dayAbbreviations.sa'),
  ]
  return (
    <div className="visitor-wrapper">
      <div className="columns">
        <div className="daySelectorPadding column is-full">
          <div className="visitorMarginTop days-selector daysSelectorMargin">
            {dayAbbreviations.map((day, i) => (
              <div
                key={i}
                className={`visitors-day-button ${selectedDays.includes(i) ? 'selected' : ''}`}
                onClick={() => handleDayToggle(i, setFieldValue, values)}
              >
                {day}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="columns">
        <div className="column is-6">
          <div className="input-container">
            <p className="input-label">{t('visitors:form.startTimeLabel')}</p>
            <DateField
              name="timeStart"
              values={values.timeStart}
              selected={values.timeStart}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption={t('visitors:form.timeCaption')}
              dateFormat="h:mm aa"
              onChange={(time) => {
                setFieldValue('timeStart', time.target.value)
              }}
              placeholderText={t('visitors:form.selectTime')}
            />
          </div>
        </div>
        <div className="column is-6">
          <div className="input-container">
            <p className="input-label">{t('visitors:form.endTimeLabel')}</p>
            <DateField
              name="timeEnd"
              values={values.timeEnd}
              selected={values.timeEnd}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption={t('visitors:form.timeCaption')}
              dateFormat="h:mm aa"
              onChange={(time) => {
                setFieldValue('timeEnd', time.target.value)
              }}
              placeholderText={t('visitors:form.selectTime')}
            />
          </div>
        </div>
      </div>
      <Note values={values} setFieldValue={setFieldValue} />
    </div>
  )
}

WeeklyForm.propTypes = {
  values: PropTypes.shape({
    timeStart: PropTypes.instanceOf(Date),
    timeEnd: PropTypes.instanceOf(Date),
    isVisitorNoteOpen: PropTypes.bool,
    visitorNote: PropTypes.string,
    selectedDays: PropTypes.arrayOf(PropTypes.number).isRequired,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  selectedDays: PropTypes.arrayOf(PropTypes.number).isRequired,
}

export default WeeklyForm
